/**
 * Smooth product switch for "Vælg tilbud" on Kanel product page only.
 * Uses Shopify Section Rendering API to fetch only the product section for the new product,
 * then replaces the current section instantly (no loading state, no transition animation).
 */
(function () {
  function initOfferPicker() {
    const productInfo = document.querySelector('product-info.main-product-kanel');
    if (!productInfo) return;

    const picker = productInfo.querySelector('[data-product-offer-picker]');
    if (!picker) return;

    picker.addEventListener('click', function (e) {
      const link = e.target.closest('a.product-offer-picker__option--link');
      if (!link) return;
      e.preventDefault();
      const href = link.getAttribute('href');
      if (!href) return;
      const pathname = (href.indexOf('://') !== -1 ? new URL(href).pathname : href).split('?')[0];
      if (pathname === window.location.pathname) return;

      const sectionWrapper = productInfo.closest('.shopify-section');
      if (!sectionWrapper) {
        window.location.href = href;
        return;
      }

      const sectionId = sectionWrapper.id ? sectionWrapper.id.replace(/^shopify-section-/, '') : '';
      const fetchUrl = href.startsWith('http') ? href : window.location.origin + (href.startsWith('/') ? href : '/' + href);
      const sectionApiUrl = fetchUrl + (fetchUrl.indexOf('?') !== -1 ? '&' : '?') + 'sections=' + encodeURIComponent(sectionId);

      function fallbackToFullNavigate() {
        window.location.href = href;
      }

      fetch(sectionApiUrl)
        .then((res) => {
          if (!res.ok) throw new Error('Section fetch failed');
          return res.json();
        })
        .then((sectionsJson) => {
          const sectionHtml = sectionId && sectionsJson[sectionId];
          if (!sectionHtml || typeof sectionHtml !== 'string') {
            fallbackToFullNavigate();
            return;
          }
          const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const newSectionFromDoc = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
          if (!newSectionFromDoc || !newSectionFromDoc.querySelector('product-info')) {
            fallbackToFullNavigate();
            return;
          }
          const newSection = document.importNode(newSectionFromDoc, true);
          // Remove scroll-reveal animation classes so the inserted section appears instantly with no animation
          newSection.querySelectorAll('.scroll-trigger').forEach((el) => {
            el.classList.add('scroll-trigger--cancel');
            el.classList.remove('scroll-trigger', 'animate--fade-in', 'animate--slide-in');
          });

          const newTitle = newSection.querySelector('.product__title h1, h1');
          const titleText = newTitle ? newTitle.textContent.trim() : '';

          const titleEl = document.querySelector('head title');
          if (titleEl && titleText) {
            const shopName = (window.Shopify && window.Shopify.shop) ? ' | ' + window.Shopify.shop : '';
            titleEl.textContent = titleText + shopName;
          }

          const wrapper = document.createElement('div');
          const HTMLUpdateUtility = window.HTMLUpdateUtility;
          if (HTMLUpdateUtility && typeof HTMLUpdateUtility.setInnerHTML === 'function') {
            HTMLUpdateUtility.setInnerHTML(wrapper, newSection.outerHTML);
          } else {
            wrapper.innerHTML = newSection.outerHTML;
          }
          const newNode = wrapper.firstElementChild;
          if (newNode) {
            sectionWrapper.parentNode.replaceChild(newNode, sectionWrapper);
            if (typeof window?.Shopify?.PaymentButton?.init === 'function') window.Shopify.PaymentButton.init();
            if (typeof window?.ProductModel?.loadShopifyXR === 'function') window.ProductModel.loadShopifyXR();
            if (window.KGallery && typeof window.KGallery.initAll === 'function') window.KGallery.initAll();
            initOfferPicker();
          }

          window.history.pushState({}, '', href);
          announceProductChange(titleText);
        })
        .catch(() => {
          fallbackToFullNavigate();
        });
    });
  }

  function announceProductChange(title) {
    let liveRegion = document.getElementById('product-offer-picker-live');
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.id = 'product-offer-picker-live';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.className = 'visually-hidden';
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = title ? `Produkt skiftet til ${title}` : 'Produkt skiftet';
    setTimeout(() => {
      liveRegion.textContent = '';
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOfferPicker);
  } else {
    initOfferPicker();
  }
})();
